import { IFiltrosPagarEReceber } from "@/features/financas/views/Indicadores/@types/type";
import PreferenciasTemplate from "../Preferencias/PreferenciasTemplate";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";

export default class PreferenciasPagarEReceber extends PreferenciasTemplate<IFiltrosPagarEReceber> {
  constructor() {
    super(EWidgets.ExempleCard);
  }
}
